import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  selectSelectedTake3D,
  updateSelectedTake,
} from "../../app/slices/TrainingSlice";
import Take3D from "../../models/Take3D";
import CameraPickingBar from "../previews/set_camera/CameraPickingBar";

/**
 * Picking the take's starting camera looks exactly like a Set Camera interaction:
 * the same bar, limited to the take location's cameras, writing take.mainCamera.
 */
export default function TakeCameraPickingBar() {
  const take = useSelector(selectSelectedTake3D);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  if (!take) return null;

  return (
    <div className="absolute inset-0 z-[11] pointer-events-none">
      <CameraPickingBar
        className="pointer-events-auto"
        title={String(t("take_starting_view", "Starting view"))}
        setCamera={take.mainCamera}
        takeLocationId={take.interactionPointId}
        onPick={(option) => {
          const updatedTake: Take3D = {
            ...take,
            mainCamera: { ...take.mainCamera, cameraId: option.id },
          };
          dispatch(updateSelectedTake(updatedTake));
        }}
      />
    </div>
  );
}
